import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
// Models
import mParkingCategory from 'models/cpm/parkingCategory';
// Custom
import { cpmParkingCategoryDataShape } from 'constants/PropTypesShapes';

const ParkingCategoryTitle = ({ parkingCategory }) => {
  // Non regular
  if (mParkingCategory.isOnDemand(parkingCategory)) {
    return (
      <LocalizedMessage id="parkingCategory.type.onDemand" />
    );
  }

  // Regular
  return (
    <span>
      {mParkingCategory.title(parkingCategory)}
    </span>
  );
};

ParkingCategoryTitle.propTypes = {
  parkingCategory: cpmParkingCategoryDataShape.isRequired,
};

module.exports = ParkingCategoryTitle;



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/parkingCategories/ParkingCategoryTitle.js